import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

const OpsHubLogo = ({
  size,
  style,
  className
}) => {
  return /*#__PURE__*/_jsx("svg", {
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    x: "0px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    y: "0px",
    width: size,
    height: size,
    style: style,
    className: className,
    children: /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M4.43064,19.63081c-0.66865,0-1.34335-0.20491-1.92422-0.63012 c-1.45367-1.06412-1.76938-3.10518-0.7052-4.55878c1.06913-1.46054,1.06913-3.42316,0-4.88363 C1.03764,8.51532,0.96208,7.1199,1.60834,6.00049C2.2546,4.88114,3.49876,4.24883,4.78592,4.38862 C6.58497,4.5846,8.28498,3.60298,9.01518,1.94673c0.7269-1.64842,2.65208-2.39552,4.3007-1.66861 c1.64848,0.72684,2.39545,2.65236,1.66868,4.30077c-1.18948,2.69742-3.37665,4.70049-5.99549,5.6828 c0.459,2.75938-0.18231,5.65484-1.9238,8.03373C6.42643,19.16817,5.4352,19.63081,4.43064,19.63081z",
        fill: "#FF7A59"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.99809,24c-0.43963,0-0.88613-0.0893-1.31423-0.27807c-1.64848-0.72684-2.39545-2.65236-1.66868-4.30077 c1.18948-2.69742,3.37665-4.70049,5.99549-5.6828c-0.459-2.75938,0.18231-5.65484,1.9238-8.03373 c1.06405-1.45367,3.10532-1.76925,4.55885-0.70527c1.45367,1.06412,1.76938,3.10518,0.7052,4.55878 c-1.06913,1.46054-1.06913,3.42316,0,4.88363c0.76359,1.04296,0.83915,2.43838,0.19289,3.55779 c-0.64626,1.11928-1.89097,1.75091-3.17758,1.61187c-1.7992-0.19543-3.49892,0.78571-4.22926,2.44188 C14.44643,23.27358,13.25131,23.99993,11.99809,24z",
        fill: "#FF7A59"
      }), /*#__PURE__*/_jsxs("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "SVGID_1_",
        x1: "9.95805",
        x2: "20.09833",
        y1: "2.04302",
        y2: "9.12009",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0%",
          stopColor: "#FF7A59"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "63.457%",
          stopColor: "#FFAC78"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M18.74768,10.9379c-4.19189,0-8.009-2.45054-9.7325-6.35901 c-0.72677-1.64842,0.0202-3.57394,1.66868-4.30077c1.64862-0.7267,3.57394,0.02033,4.3007,1.66861 c0.7302,1.65618,2.42842,2.63766,4.22926,2.44181c1.79246-0.19481,3.40083,1.09929,3.59551,2.89017 c0.19481,1.79095-1.09922,3.40069-2.89017,3.59551C19.52638,10.91695,19.13538,10.9379,18.74768,10.9379z",
        fill: "url(#SVGID_1_)"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "19.56848",
        cy: "7.63086",
        fill: "#FF7A59",
        r: "3.26051"
      }), /*#__PURE__*/_jsxs("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "SVGID_00000173848033308065459110000004773122919053972901_",
        x1: "2.67605",
        x2: "14.29513",
        y1: "14.1314",
        y2: "21.94787",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "36.543%",
          stopColor: "#FFAC78"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopColor: "#FF7A59"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.00166,24 c-1.25336,0-2.44834-0.72629-2.98648-1.94668c-0.7302-1.65618-2.42842-2.63841-4.22926-2.44181 c-1.79178,0.19406-3.40069-1.09929-3.59551-2.89017c-0.19481-1.79095,1.09922-3.40069,2.89017-3.59551 c4.64018-0.50462,9.02112,2.0254,10.90398,6.29533c0.72677,1.64842-0.0202,3.57394-1.66868,4.30077 C12.88793,23.91063,12.44115,24,12.00166,24z",
        fill: "url(#SVGID_00000173848033308065459110000004773122919053972901_)"
      })]
    })
  });
};

export default OpsHubLogo;